import{jsx as _jsx}from"react/jsx-runtime";import{overrideDefaultClasses}from"../theming/index.js";import{cardBaseStyles}from"./cardBaseStyles.js";/**
 * A card component.
 *
 * @param props The props for the card, aligns with the HTMLDivElement.
 * @returns The card component.
 */export const Card=props=>{const adjustedProps=overrideDefaultClasses(props,cardBaseStyles);return /*#__PURE__*/_jsx("div",{"data-component-type":"card",...adjustedProps})};